module.exports = __webpack_public_path__ + "dist/media/about-background.5ea959c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/about-background.png
// module id = 367
// module chunks = 0